import React from 'react'
import Helmet from 'react-helmet'
import isNode from 'is-node'
import { IntlProvider } from 'react-intl'
import { t as typy } from 'typy'
import { inject, observer } from 'mobx-react'

import { getCurrentSiteData } from 'src/helpers/getCurrentSiteData'
import { getSeoData } from 'src/helpers/getSeoData'
import configs from 'src/json/siteconfigs.json'
import footers from 'src/json/footerconfigs.json'
import menus from 'src/json/menus.json'
import Cookie from 'src/stores/cookie'
import Preview from 'src/stores/preview'
import { getBrandByName } from 'src/utils/brand'
import { getMessagesByLocale } from 'src/utils/intl'

import Header from './Header/Header'
import Cart from './Cart/Cart'
import Footer from './Footer/Footer'
import CookieConsent from './CookieConsent/CookieConsent'
import SEO from './SEO/SEO'
import { LanguageProvider } from './LanguageContext'

type Props = {
  children: any
  location?: any
  pageContext: any
  cookie: Cookie
  preview: Preview
}

@inject('cookie', 'preview')
@observer
class Layout extends React.Component<Props> {
  render() {
    const { children, location, pageContext, cookie, preview } = this.props
    const locale = typy(pageContext, 'locale').safeObject
      ? typy(pageContext, 'locale').safeObject
      : 'sv'
    let config = getCurrentSiteData(configs, locale)
    let menu = getCurrentSiteData(menus, locale)
    let footer = getCurrentSiteData(footers, locale)

    const messages = getMessagesByLocale(locale)

    let brandId = typy(pageContext, 'page.centraId').safeObject

    if (!brandId) {
      brandId = typy(pageContext, 'page.brand').safeObject
      if (brandId && brandId !== 'None') {
        brandId = getBrandByName(brandId)
        if (brandId) {
          brandId = brandId.centraId
        } else {
          brandId = null
        }
      }
    }

    if (preview && preview.previewData) {
      const previewConfig = preview.getCurrentPageContext(
        config.contentType,
        config.locale
      )
      const previewMenu = preview.getCurrentPageContext(
        menu.contentType,
        menu.locale
      )
      const previewFooter = preview.getCurrentPageContext(
        footer.contentType,
        footer.locale
      )

      if (previewFooter) {
        footer = previewFooter
      }
      if (previewConfig) {
        config = previewConfig
      }
      if (previewMenu) {
        menu = previewMenu
      }
    }

    const { seoData = null } = config || {}
    const { seoMetaDescription, seoTitle, seoOgimage } = getSeoData(seoData)
    return (
      <LanguageProvider locale={locale}>
        <IntlProvider key={locale} locale={locale} messages={messages}>
          <React.Fragment>
            <Helmet
              titleTemplate={`%s | ${seoTitle}`}
              defaultTitle={seoTitle}
            />
            <SEO
              type="website"
              seoOgimage={seoOgimage}
              seoMetaDescription={seoMetaDescription}
              lang={locale}
            />
            <Helmet>
              <html lang={locale || 'sv'} />
            </Helmet>
            <Header
              activeBrand={brandId}
              menu={menu}
              location={location}
              config={config}
            />
            <Cart />
            {children}
            <Footer footer={footer} />
            {cookie &&
              !cookie.isAccepted &&
              config.cookieConsentText &&
              !isNode && (
                <CookieConsent
                  content={config.cookieConsentText}
                  removeCookie={cookie.setCookieAccepted}
                />
              )}
          </React.Fragment>
        </IntlProvider>
      </LanguageProvider>
    )
  }
}

export default Layout
